// Orchestrator phase 4: validate input → gọi gh repo create → return URLs.
// Caller chịu trách nhiệm đảm bảo gh đã auth (gọi ensureGitHubReady trước).
import { type ExecuteGhRepoCreateOutput, executeGhRepoCreate } from "./execute-gh-repo-create.js";
import { resolveGithubUsernameDefault } from "./resolve-github-username-default.js";
import { log } from "./terminal-logger.js";
import {
  type RepoVisibility,
  validateRepoName,
  validateRepoVisibility,
} from "./validate-repo-name-and-visibility.js";

export interface CreateGithubRemoteInput {
  folder: string;
  name: string;
  visibility: RepoVisibility;
  org?: string; // mặc định = GitHub login của user
}

export function createGithubRemoteFromFolder(
  input: CreateGithubRemoteInput,
): ExecuteGhRepoCreateOutput {
  validateRepoName(input.name);
  validateRepoVisibility(input.visibility);

  const org = input.org ?? resolveGithubUsernameDefault();
  log.info(`Tạo GitHub repo ${org}/${input.name} (${input.visibility})...`);

  const urls = executeGhRepoCreate({
    folder: input.folder,
    org,
    name: input.name,
    visibility: input.visibility,
  });

  log.success(`Đã tạo: ${urls.sshUrl}`);
  return urls;
}
